import React from 'react'
import { Card, Table } from 'antd';
import { auditTrailTable } from '../../../Utils/constants';
import AuditTrailTableDes from './AuditTrailTableDes';
import NoDataFound from '../../Helpers/NoDataFound';
const AuditTrailTable = ({ data = [] }) => {

    return (
        <div>
            {
                data?.length ?
                    <Table
                        columns={auditTrailTable.column}
                        expandable={{
                            expandedRowRender: (record) => (
                                < div
                                    style={{
                                        margin: 0,
                                    }}
                                >
                                    <div className='DescriptionCard'> <AuditTrailTableDes test={record} data={record} /></div>
                                </div>),
                            rowExpandable: record => {
                                if (record?.detailsAfter || record?.detailsBefore) return record
                                return null
                            }
                        }}
                        bordered
                        expandRowByClick={false}
                        dataSource={data || []}
                    />
                    :
                    <NoDataFound />
            }
        </div >
    )
}

export default AuditTrailTable